<template lang="pug">
//- 頁尾社群連結（2026-10-03：圖示改用 ui/Icon.vue 內嵌 SVG，不再載 FontAwesome）
.social-links
  a(
    v-for="link in socialLinks",
    :key="link.label",
    :href="link.href",
    :target="link.external ? '_blank' : undefined",
    :rel="link.external ? 'noopener noreferrer' : undefined",
    :title="link.label",
    :aria-label="link.label"
  )
    Icon(:name="link.icon")
  pre cheyu.wu@monoame.com
</template>
<script>
import Icon from './ui/Icon.vue'

export default {
  components: { Icon },
  data() {
    return {
      socialLinks: [
        { href: 'https://www.linkedin.com/in/cheyuwu/?locale=en_US', external: true, label: 'LinkedIn', icon: 'linkedin' },
        { href: 'https://www.instagram.com/cheyuwu345/', external: true, label: 'Instagram', icon: 'instagram' },
        { href: 'mailto:cheyu.wu@monoame.com', external: false, label: 'Email', icon: 'envelope' },
        { href: 'https://codepen.io/frank890417', external: true, label: 'CodePen', icon: 'codepen' },
        { href: 'https://github.com/frank890417', external: true, label: 'GitHub', icon: 'github' },
        { href: 'https://medium.com/@wucheyu', external: true, label: 'Medium', icon: 'medium' },
        { href: 'http://issuu.com/wucheyu/docs/2017_portfolio', external: true, label: 'Portfolio on ISSUU', icon: 'book' },
      ],
    }
  },
}
</script>
